// PayableDetail.slice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PayableDetailState {
  /**
   * 📌 Detalle actual cargado
   */
  detail: any | null;

  /**
   * 🆔 ID seleccionado para ver detalle
   */
  selectedPayableId: number | null;

  /**
   * 🪟 Estado del modal
   */
  isModalOpen: boolean;

  /**
   * 🔄 loading general
   */
  loading: boolean;

  /**
   * ❌ error global
   */
  error: string | null;
}

const initialState: PayableDetailState = {
  detail: null,

  selectedPayableId: null,
  isModalOpen: false,

  loading: false,
  error: null,
};

const PayableDetailSlice = createSlice({
  name: "payableDetail",
  initialState,
  reducers: {
    /**
     * 🔄 loading
     */
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    /**
     * ❌ error
     */
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    /**
     * 📌 set detail
     */
    setPayableDetail(state, action: PayloadAction<any>) {
      state.detail = action.payload;
      state.loading = false;
    },

    /**
     * 🪟 abrir modal
     */
    openDetailModal(
      state,
      action: PayloadAction<number>
    ) {
      state.selectedPayableId = action.payload;
      state.isModalOpen = true;
    },

    /**
     * ❌ cerrar modal
     */
    closeDetailModal(state) {
      state.isModalOpen = false;
    },

    /**
     * 🧹 limpiar detalle completo
     */
    clearPayableDetail(state) {
      state.detail = null;
      state.selectedPayableId = null;
      state.isModalOpen = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setPayableDetail,
  openDetailModal,
  closeDetailModal,
  clearPayableDetail,
} = PayableDetailSlice.actions;

export default PayableDetailSlice.reducer;